import type { WhatsNewEntry } from "../types";

/** Release note: 性能 + 反馈改版 combined release (2026-06-27). */
const BODY = `这次有两块更新，用起来都能感觉到：小环**更快、更轻、更稳，还越用越聪明**；给反馈、改答案也**更顺手**了。

## 一、性能：更快、更轻、更稳，还越用越聪明

![三项关键提升](/whatsnew/perf-pillars.png)

**⚡ 更快**：点完发送，小环开口更快，几乎话音刚落就开始作答。

**🪶 更轻**：对话越长省得越多——聊到第 15 轮，要处理的内容从 14,562 降到 6,221，**少了一多半（−57%）**，长对话不再越聊越卡。

**💰 更省**：同样的用量花得更少——处理 1000 万字输入，成本约 **¥25 → ¥10（省 60%）**。

**🛡 更稳**：**答案质量实测无损**，聊得再久也前后一致、不丢细节，早先聊过的内容还能精准接上。

**🧠 更聪明**：你常问的、认可过的会被记住、自然复用，复用命中率从实测 **71%** 随使用走高（预估 **80%**）。

## 二、反馈：给反馈、改答案都更顺手

**点踩面板，集中一处**：没解决点个踩，直接勾原因（可多选）、补一句、还能**贴张截图**；点错再点一下就撤回。

![点踩后：多选原因 + 备注 + 截图，可撤回](/whatsnew/feedback-panel.png)

**标注台：带着你的反馈来改**：你点过踩、转过人工的会汇到「标注台」。**以前评审只看得到问答；现在能看到当时的反馈上下文**——原因、补充、截图都在，照着改更省事。

![标注台升级：评审时带上用户反馈上下文](/whatsnew/review-userctx.png)

---

> 数据来自线上真实用量与基准测试；成本为估算。**答案质量实测无损。**

一句话：小环这次**更快、更轻、更稳、越用越聪明**，反馈也更顺手——有哪里不顺手，随时回消息找我。`;

export const perfFeedbackRelease: WhatsNewEntry = {
  id: "2026-06-27-release",
  date: "2026-06-27",
  title: "更快、更轻、更稳，反馈也更顺手",
  summary:
    "两块更新：性能（开口更快、长对话更轻不卡、越用越聪明）+ 反馈改版（点踩多选原因/截图/可撤回，标注台带上反馈上下文）。",
  video: "/whatsnew/perf-experience.mp4",
  body: BODY
};
